module.exports = __webpack_public_path__ + "img/ga.b080db2c.jpg";